module.exports = __webpack_public_path__ + "static/media/interMobile_1.1d95ed4b.jpg";